module.exports = __webpack_public_path__ + "img/home_seedling.64241151.png";